import { render, staticRenderFns } from "./downloadStatement.vue?vue&type=template&id=b4ccd43a&scoped=true&"
import script from "./downloadStatement.vue?vue&type=script&lang=js&"
export * from "./downloadStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ccd43a",
  null
  
)

export default component.exports